<template>
    <div class="ball-container">
        <transition-group tag="div" @before-enter='beforeEnter' @enter='enter' @after-enter='afterEnter'>
            <div class="ball" v-for="(item, index) in balls" :key="item.index" v-show="item.show" transition='drop'>
            <div class="inner inner-hook"><img :src="avatar"></div></div>
        </transition-group>
    </div>
</template>
<script>
export default {
  props: ["avatar"],
  data() {
    return {
      balls: [
        { index:0,show: false },
        {  index:1,show: false },
        {  index:2,show: false },
        {  index:3,show: false },
        {  index:4,show: false },
        {  index:5,show: false },
        { index:6, show: false },
        {  index:7,show: false },
        {  index:8,show: false }
      ],
      dropBalls: []
    };
  },

  methods: {
    drop(target) {
      for (var i = 0; i < this.balls.length; i++) {
        var ball = this.balls[i];
        if (!ball.show) {
          ball.show = true;
          ball.el = target;
          this.dropBalls.push(ball);
          return;
        }
      }
    },
    beforeEnter(el) {
      let count = this.balls.length;
      while (count--) {
        let ball = this.balls[count];
        if (ball.show) {
          // 让动画效果异步执行,提高性能
          el.style.webkitTransform = "translate3d(0, 0, 0)";
          el.style.transform = "translate3d(0, 0, 0)";
          // 处理内层动画
          let inner = el.getElementsByClassName("inner-hook")[0]; // 使用inner-hook类来单纯被js操作
          inner.style.webkitTransform = "translate3d(0, 0, 0)";
          inner.style.transform = "translate3d(0, 0, 0)";


          //sidebar处理
          document.getElementById('global-cart-in').className="active cart"
        }
      }
    },
    enter(el, done) {
      /* eslint-disable no-unused-vars */
      let rf = el.offsetHeight; // 触发重绘html
      this.$nextTick(() => {
        let rect = el.getBoundingClientRect();

        //接收小球的地方
        let reactIn = document.getElementById('global-cart-in').getBoundingClientRect();

        let x = window.innerWidth - rect.left-40;
        let y = reactIn.top+reactIn.height/ 2 - rect.top;//负数是从左上角往下的的方向, 正数是往上

        el.style.display = ""; // 清空display
        el.style.webkitTransform = `translate3d(0, ${y}px, 0)`;
        el.style.transform = `translate3d(0, ${y}px, 0)`;
        // 处理内层动画
        let inner = el.getElementsByClassName("inner-hook")[0]; // 使用inner-hook类来单纯被js操作
        inner.style.webkitTransform = `translate3d(${x}px, 0, 0)`;
        inner.style.transform = `translate3d(${x}px, 0, 0)`;

        el.addEventListener("transitionend", done); // Vue为了知道过渡的完成，必须设置相应的事件监听器。
      });
    },
    afterEnter(el) {
      let ball = this.dropBalls.shift(); // 完成一次动画就删除一个dropBalls的小球
      if (ball) {
        ball.show = false;
        el.style.display = "none"; // 隐藏小球
      }

      document.getElementById('global-cart-in').className="cart shake"
    }
  }
};
</script>
<style scoped lang="scss">
.ball-container {
  position: absolute;
  z-index: 1;
  .ball {
    &.v-enter-active {
      /* https://obooman.github.io/cubic-bezier-curve/demos/cubic-bezier-path-describe-timing-function.html */
      transition: all 0.8s cubic-bezier(0.00,0.99,1.00,1.01);
    }

    .inner {
      width: 30px;
      height: 30px;
      transition: all 0.8s linear;
      img {
        border-radius: 50%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/_widget/CartBalls.vue